export default __webpack_public_path__ + "static/media/airport-management.097766a1.svg";